import { useTranslation } from 'react-i18next'
import { useSelectionStore } from '@/stores'
import { MoveIcon, SelectIcon } from '@/components/ui/icons'
import { Tooltip, TOOLBAR_TOOLTIP_DELAY_MS } from '@/components/ui/Tooltip'

function modeButtonStyles(active: boolean) {
  return {
    borderColor: active ? 'var(--accent)' : 'var(--border)',
    background: active ? 'rgba(99,102,241,.14)' : 'var(--bg-card)',
    color: active ? 'var(--accent)' : 'var(--text-muted)',
  }
}

export function ModeButtons() {
  const { t } = useTranslation()
  const canvasMode = useSelectionStore((state) => state.canvasMode)
  const setCanvasMode = useSelectionStore((state) => state.setCanvasMode)

  return (
    <div
      data-guide="canvas-modes"
      className="flex items-center overflow-hidden rounded-md border"
      style={{ borderColor: 'var(--border)' }}
    >
      <Tooltip content={t('toolbar.moveTitle')} delayMs={TOOLBAR_TOOLTIP_DELAY_MS}>
        <button
          type="button"
          aria-label={t('toolbar.moveTitle')}
          onClick={() => setCanvasMode('pan')}
          className="inline-flex h-[30px] w-full items-center justify-center gap-2 px-3 text-[11px] font-medium transition-colors"
          style={modeButtonStyles(canvasMode === 'pan')}
        >
          <MoveIcon />
          {t('toolbar.move')}
        </button>
      </Tooltip>
      <div className="h-5 w-px" style={{ background: 'var(--border)' }} />
      <Tooltip content={t('toolbar.selectTitle')} delayMs={TOOLBAR_TOOLTIP_DELAY_MS}>
        <button
          type="button"
          aria-label={t('toolbar.selectTitle')}
          onClick={() => setCanvasMode('select')}
          className="inline-flex h-[30px] w-full items-center justify-center gap-2 px-3 text-[11px] font-medium transition-colors"
          style={modeButtonStyles(canvasMode === 'select')}
        >
          <SelectIcon />
          {t('toolbar.select')}
        </button>
      </Tooltip>
    </div>
  )
}
